var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDistributor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#899ba2;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M960.066,600.111h0a8,8,0,0,0-8,8h0a8,8,0,0,0,3.845,6.837,10.884,10.884,0,0,1,3.636-10.357l-1.473-1.865,6.314.859-.627,6.341-1.473-1.865a11.485,11.485,0,0,0-4.247,7.789,8.018,8.018,0,0,0,2.026.259h0a8,8,0,0,0,8-8h0A8,8,0,0,0,960.066,600.111Z",
    transform: "translate(-952.066 -600.111)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistributor);
export default __webpack_public_path__ + "static/media/distributor.8021522bca468fb76f6b95367b60b3ba.svg";
export { ForwardRef as ReactComponent };